import { createContext, useContext, type ReactNode } from "react";
import type { NodeOutputRecord } from "./operationInspector/nodeInspectorWidgets.js";

const OperationNodeOutputsContext = createContext<Record<string, NodeOutputRecord>>({});

/** Supplies hub `/node-outputs` stats for operation graph canvas (tooltips read here, not from `node.data`). */
export function OperationNodeOutputsProvider({
  value,
  children
}: {
  value: Record<string, NodeOutputRecord>;
  children: ReactNode;
}) {
  return <OperationNodeOutputsContext.Provider value={value}>{children}</OperationNodeOutputsContext.Provider>;
}

export function useOperationNodeOutputMap(): Record<string, NodeOutputRecord> {
  return useContext(OperationNodeOutputsContext);
}
